import rg4js from 'raygun4js'

const log = payload => {
    rg4js('send', payload)
}

export default {
    log,
}
